import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import { FilterList as FilterIcon } from '@material-ui/icons'
import { CorporatesFilterModal, ICorporateFilterFormValues } from './CorporatesFilterModal'

interface IProps {
  onChangeFilter: (filter: ICorporateFilterFormValues) => void
}

export function CorporatesFilter({ onChangeFilter }: IProps) {
  const [modalVisible, setModalVisible] = useState(false)

  const handleOpen = () => {
    setModalVisible(true)
  }

  const handleClose = () => {
    setModalVisible(false)
  }

  const handleSubmit = (values: ICorporateFilterFormValues) => {
    onChangeFilter(values)
    handleClose()
  }

  return (
    <>
      <IconButton onClick={handleOpen}>
        <FilterIcon />
      </IconButton>
      <CorporatesFilterModal open={modalVisible} onSubmit={handleSubmit} onCancel={handleClose} />
    </>
  )
}
